import React, { useState, useEffect } from 'react';
import useData from '../../hooks/useData';

const ActivityHistory = ({ task }) => {
    const { fetchUserProfiles, userProfiles, currentUserProfile } = useData();
    const history = task.history || [];

    useEffect(() => {
        const authorIds = [...new Set(history.map(h => h.user).filter(Boolean))];
        if (authorIds.length > 0) {
            fetchUserProfiles(authorIds);
        }
    }, [task.history, fetchUserProfiles, currentUserProfile]);

    const formatTimestamp = (isoString) => {
        if (!isoString) return '';
        return new Date(isoString).toLocaleString('pt-BR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }).replace('.', ',');
    };

    return (
        <div className="bg-transparent rounded-lg">
            <div className="space-y-4 max-h-48 overflow-y-auto p-2">
                {history.length > 0 ? (
                    [...history].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)).map((entry, index) => {
                        const author = userProfiles[entry.user];
                        const authorName = author?.username || 'Usuário';
                        const authorAvatarUrl = author?.avatarUrl;

                        return(
                            <div key={index} className="flex items-start gap-3 text-sm">
                                <div className="w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-full flex-shrink-0 mt-1 overflow-hidden">
                                    {authorAvatarUrl ? (
                                        <img src={authorAvatarUrl} alt={authorName} className="w-full h-full object-cover" />
                                    ) : (
                                        <div className="w-full h-full flex items-center justify-center text-xs font-bold text-gray-500">
                                            {authorName.substring(0, 2).toUpperCase()}
                                        </div>
                                    )}
                                </div>
                                <div className="flex-1">
                                    <p className="text-gray-600 dark:text-gray-200">
                                        <span className="font-semibold text-gray-800 dark:text-white">{authorName}</span> {entry.action}
                                    </p>
                                    <p className="text-xs text-gray-500">{formatTimestamp(entry.timestamp)}</p>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <p className="text-sm text-gray-400 text-center">Nenhuma atividade registrada.</p>
                )}
            </div>
        </div>
    );
};

export default ActivityHistory;